import { compose } from 'redux';
import { Box, Grid } from '@material-ui/core';
import withStyles from '@material-ui/styles/withStyles';
import { useSelector, connect, useDispatch } from 'react-redux';
import { useEffect, useCallback, useRef, useState } from 'react';

import { useModal } from 'altus-modal';

import {
  onUnload,
  searchBhas,
  getAllToolStrings,
} from 'features/equipment/equipment.actions';

import { EMPTY_STRING } from 'app/app.constants';
import { MODAL } from 'features/equipment/equipment.constants';
import { getBhaTemplatesFromState } from 'features/equipment/equipment.selectors';
import { Filters } from 'features/equipment/toolAssemblies/components/ToolAssembliesFilter';
import BhaTemplatesTable from 'features/equipment/bhaTemplates/components/BhaTemplatesTable';
import BhaTemplatesFilter from 'features/equipment/bhaTemplates/components/BhaTemplatesFilter';
import EditTemplateContainer from 'features/equipment/bhaTemplates/editBhaTemplates/EditTemplateContainer';
import AddBhaTemplatesModalContainer from 'features/equipment/bhaTemplates/addBhaTemplates/AddBhaTemplatesModalContainer';

const defaultFormValues = {
  [Filters.TEXT_SEARCH]: EMPTY_STRING,
};

const BhaTemplateContainer = ({
  classes,
  dispatchOnUnload,
  dispatchOnSearch,
}) => {
  const dispatch = useDispatch();
  useEffect(() => {
    return () => {
      dispatchOnUnload();
    };
  }, [dispatchOnUnload]);

  const [addBhaTemplateModal, toggleAddBhaTemplateModal] = useModal(
    MODAL.ADD_BHA_TEMPLATE,
  );

  const [editBhaTemplateModal, toggleEditBhaTemplateModal] = useModal(
    MODAL.EDIT_BHA_TEMPLATE,
  );

  const [initialFilterValues] = useState(defaultFormValues);

  const formRef = useRef(null);

  const submitForm = () => {
    formRef.current?.submitForm();
  };

  const [templateIdForEdit, setTemplateIdForEdit] = useState(null);

  const bhaTemplates = useSelector(getBhaTemplatesFromState);

  const handleSearch = useCallback(
    (filterValues) => {
      dispatchOnSearch({
        [Filters.TEXT_SEARCH]: filterValues[Filters.TEXT_SEARCH],
      });
    },
    [dispatchOnSearch],
  );

  const onEditTemplate = (templateId) => {
    setTemplateIdForEdit(templateId);
    toggleEditBhaTemplateModal();
  };

  const onCloseEditTemplate = () => {
    setTemplateIdForEdit(null);
    dispatch(getAllToolStrings());
    toggleEditBhaTemplateModal();
    submitForm();
  };

  return (
    <Grid container>
      <Grid item xs={12} container component={Box} direction="column">
        <Grid item className={classes.filterContainer}>
          <BhaTemplatesFilter
            ref={formRef}
            onSubmit={handleSearch}
            initialValues={initialFilterValues}
            toggleAddBhaTemplateModal={toggleAddBhaTemplateModal}
          />
        </Grid>
        <Grid item container className={classes.tableContainer}>
          <BhaTemplatesTable
            bhaTemplates={bhaTemplates}
            onEditTemplate={onEditTemplate}
          />
        </Grid>
      </Grid>
      <AddBhaTemplatesModalContainer
        openModal={addBhaTemplateModal}
        toggleModal={toggleAddBhaTemplateModal}
      />
      {editBhaTemplateModal && (
        <EditTemplateContainer
          open={editBhaTemplateModal}
          onClose={onCloseEditTemplate}
          templateId={templateIdForEdit}
        />
      )}
    </Grid>
  );
};

const styles = () => ({
  filterContainer: {
    height: 'fit-content',
    width: '40%',
  },
  tableContainer: {
    flex: 1,
  },
});

export default compose(
  connect(() => ({}), {
    dispatchOnUnload: onUnload,
    dispatchOnSearch: searchBhas,
  }),
  withStyles(styles),
)(BhaTemplateContainer);
